export default __webpack_public_path__ + "static/media/nftlandingpagelightMode.b69d77bb.png";